module.exports = __webpack_public_path__ + "d9ee23d59d0e0e727b51368b458a0bff.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/fontawesome-webfont.woff?v=4.3.0
// module id = 1091
// module chunks = 0